package com.solevo.dist.network.infrastructure.utils

class DefaultRemoteSourceImplementationException: Throwable("Default implementation of remote source should not be called. Please check if correct implementation is provided")